import { defineStore, acceptHMRUpdate } from "pinia";

export const useMenuStore = defineStore("menu", {
  state: () => ({
    isClicked: false as boolean,
  }),
  getters: {},
  actions: {
    async clickedMenuItem(clicked) {
      this.isClicked = clicked;
    },
  },
});
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useMenuStore, import.meta.hot));
}
